import { ContentType, UserSubscription } from '@creditsights/api-ui-web';
import { invert } from 'lodash';
import { ContentTypeFilter } from '../../models';
import { SortOption } from '../../services/services.constants';

export enum SearchResultCategory {
  All = 'All',
  Companies = 'Companies',
  Research = 'Research',
  Covenants = 'Covenants',
  News = 'News',
}
export const ContentTypeToSearchResultCategoryMap = {
  [ContentType.Research]: SearchResultCategory.Research,
  [ContentType.Covenants]: SearchResultCategory.Covenants,
  [ContentType.News]: SearchResultCategory.News,
};

export const ContentTypeFilterToSearchResultCategoryMap = {
  [ContentTypeFilter.RESEARCH]: SearchResultCategory.Research,
  [ContentTypeFilter.COVENANTS]: SearchResultCategory.Covenants,
  [ContentTypeFilter.NEWS]: SearchResultCategory.News,
};
export const SearchResultCategoryToContentTypeMap = invert(ContentTypeToSearchResultCategoryMap) as {
  [key in SearchResultCategory]?: ContentType;
};

export const SearchResultCategoryToContentTypeFilterMap = invert(ContentTypeFilterToSearchResultCategoryMap) as {
  [key in SearchResultCategory]?: ContentTypeFilter;
};

export const SEARCH_RESULTS_CATEGORY_BUTTONS = [
  {
    label: SearchResultCategory.All,
    value: SearchResultCategory.All,
  },
  {
    label: SearchResultCategory.Companies,
    value: SearchResultCategory.Companies,
  },
  {
    label: SearchResultCategory.Research,
    value: SearchResultCategory.Research,
  },
  {
    label: SearchResultCategory.Covenants,
    value: SearchResultCategory.Covenants,
  },
  {
    label: SearchResultCategory.News,
    value: SearchResultCategory.News,
  },
];

export const SEARCH_RESULT_DEFAULT_SORT_OPTION = SortOption.relevance;

export const SEARCH_RESULT_SORT_OPTIONS: SortOption[] = [SortOption.relevance, SortOption.publishDate_desc];

export const SEARCH_TERM_URL_KEY = 'searchTerm';

export enum SECTION_ID {
  COMPANIES = 'COMPANIES',
  RESEARCH = 'RESEARCH',
  NEWS = 'NEWS',
  COVENANTS = 'COVENANTS',
}

export const DEFAULT_SECTION_ORDER_CONFIG = (userSubscription: UserSubscription): SECTION_ID[] => {
  switch (userSubscription) {
    case UserSubscription.CR:
      return [SECTION_ID.COMPANIES, SECTION_ID.COVENANTS, SECTION_ID.RESEARCH, SECTION_ID.NEWS];
    case UserSubscription.LFI:
      return [SECTION_ID.COMPANIES, SECTION_ID.NEWS, SECTION_ID.RESEARCH, SECTION_ID.COVENANTS];
    case UserSubscription.CR_LFI:
      return [SECTION_ID.COMPANIES, SECTION_ID.COVENANTS, SECTION_ID.NEWS, SECTION_ID.RESEARCH];
    case UserSubscription.CS_LFI:
      return [SECTION_ID.COMPANIES, SECTION_ID.RESEARCH, SECTION_ID.NEWS, SECTION_ID.COVENANTS];
    default:
      return [SECTION_ID.COMPANIES, SECTION_ID.RESEARCH, SECTION_ID.COVENANTS, SECTION_ID.NEWS];
  }
};
